<template>
  <v-container>
    <v-alert type="error" prominent> Route not found </v-alert>
  </v-container>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
